export default __webpack_public_path__ + "static/media/buildings@372.40ce013c.jpg";